import { httpClient } from './httpClient';
import { UserEventResponse, UserEventListResponse } from '../types/userEvent';

export const userEventService = {
  async listMyEvents(): Promise<UserEventListResponse> {
    return httpClient.get<UserEventListResponse>('users/me/events');
  },

  async addMyEvent(eventId: string): Promise<UserEventResponse> {
    return httpClient.post<UserEventResponse>(`users/me/events/${eventId}`);
  },

  async removeMyEvent(eventId: string): Promise<void> {
    return httpClient.delete(`users/me/events/${eventId}`);
  },
};
